<!--
설 명 : 업무공유 모바일 통합 설치 페이지
이 력 : 2021.05.18 최초 생성
       2021.05.20 1. 배경 기본 색상에서 흰색으로 변경 처리 2. 가로 사이즈 모바일에 맞게 기본 div id 삭제 , 문지현
-->
<template>
<div class="wrapper " style="max-width:375px; margin:0 auto; "><!-- .footer-menu 추가시 하단 메뉴 보임 -->
    <div class="appinfo">
        <h1>{{ $i18nUtil.trans("message.Appstore.001","업무공유 앱 설치 안내") }}</h1>
        <h2>{{ $i18nUtil.trans("message.Appstore.002","업무공유 앱을 설치해보세요.") }}</h2>
        <p class="appinfo-txt1" v-html="$i18nUtil.trans('message.Appstore.003','업무공유 시스템을 모바일 앱에서 효율적으로 관리할 수 있습니다.')"></p>
        <div class="appinfo-img"><img src="@/assets/img/img-appinfo.png" alt="이미지"> </div>
        <div class="bot-btn-group center type01">
            <button type="button" class="btn single btn-dark" @click="downLoadApp"><span>{{ $i18nUtil.trans("message.Appstore.004","업무공유 앱 설치") }}</span></button>
        </div>
        <div class="bot-btn-group center type01">
            <button type="button" class="btn single btn-dark" style="font-size: large;" @click="downLoadAppForS24"><span>{{ $i18nUtil.trans("message.Appstore.006","업무공유(Galaxy S24 전용)") }}</span></button>
        </div>
        <p class="appinfo-txt2" v-html="$i18nUtil.trans('message.Appstore.005','업무공유 앱을 사용하기 위해서는 iOS 8.0이상, Android 4.4(Kitkat)이상의 OS를 지원하며 이용하기 위해서는 업무공유시스템 계정이 필요합니다.')"></p>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            domain : null,
            isDef : null,
            iphone : null,
            notch : null,
        }
    },
    created () {
        // 배경 흰색 처리
        document.body.style.background = '#fff';
        this.handleInit();
    },
    mounted(){
        // 가로 사이즈 모바일에 맞게 기본 div id 삭제
        document.querySelector('div').setAttribute("id", "")

        this.mobileCheck();
        this.defCheck();
    },    
    methods: {
        handleInit() {
            let obj = this;
            /* 다국어 설정(브라우저 언어 별) */
            let locale = navigator.language || navigator.userLanguage;
            locale = locale.substring(0, 2);
            if (locale !== "ko") {
                locale = "en";
            }
            localStorage.setItem('defaultLanguage', locale);
            obj.$i18n.locale = locale;
        },        
        mobileCheck(){
            let obj = this;
            let agent = navigator.userAgent.toLowerCase();
            obj.iphone = agent.indexOf("iphone") > -1 ? true : false // OS 아이폰 여부
            obj.notch = agent.indexOf("iphone os 13") > -1 ? true : false // 아이폰 노치 모델인지 여부
            // /mozilla/5.0 (iphone; cpu iphone os 13_2_3 like mac os x) applewebkit/605.1.15 (khtml, like gecko) mobile/15e148/honemobile (4396609920)
            console.log('iphone > '+obj.iphone , navigator.userAgent.toLowerCase());
            console.log('iphone notch > '+obj.notch , navigator.userAgent.toLowerCase());
        },
        defCheck() {
            let obj = this;
            obj.domain = location.host;
            if(obj.domain.indexOf("def")) {
                obj.isDef = false;
            } else {
                obj.isDef = true;
            }
        },
        downLoadApp() {
            let obj = this;
            if (obj.isDef) {
                if (obj.iphone || obj.notch) {
                    // 방산 iOS
                    window.location = "itms-services://?action=download-manifest&url=https://appstore.hanwha.com/api/iphone/plist/-y__launcher__DEFOKRCOWORK__iOS__All-";
                } else {
                    // 방산 안드로이드
                    window.location = "https://appstore.hanwha.com/api/download?type=launcher&launcherAppId=DEFOKRCOWORK&deviceOs=Android&deviceType=All";
                }            
            } else {
                if (obj.iphone || obj.notch) {
                    // 금융 iOS
                    window.location = "itms-services://?action=download-manifest&url=https://appstore.hanwha.com/api/iphone/plist/-y__launcher__OKRCOWORK__iOS__All-";
                } else {
                    // 금융 안드로이드
                    window.location = "https://appstore.hanwha.com/api/download?type=launcher&launcherAppId=OKRCOWORK&deviceOs=Android&deviceType=All";
                }
            }
        },
        downLoadAppForS24() {
            window.location = "https://appstore.hanwha.com/api/operations/download/file?type=launcher&launcherAppId=OKRCOWORK&deviceOs=Android&deviceType=All64";
        }
    },
}
</script>

<style scoped>
@font-face {
    font-family: 'LIFEPLUS-Medium';
    src: local(※);
    src: url('../../../../assets/css/fonts/LIFEPLUS-Medium.woff') format('embeded-opentype');
    src: url('../../../../assets/css/fonts/LIFEPLUS-Medium.woff') format('woff');
    src: url('../../../../assets/css/fonts/LIFEPLUS-Medium.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'LIFEPLUS-Bold';
    src: local(※);
    src: url('../../../../assets/css/fonts/LIFEPLUS-Bold.eot') format('embeded-opentype');
    src: url('../../../../assets/css/fonts/LIFEPLUS-Bold.woff') format('woff');
    src: url('../../../../assets/css/fonts/LIFEPLUS-Bold.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
}


/* DEFAULT */
html {
    height: 100%;
    font-size: 10px;
}
body, h1, h2, h3, h4, h5, h6, fieldset, ul, ol, dl, dt, dd, p, button, figure, xmp {
    margin: 0;
    padding: 0;
}
body {
    font-size: 1.6rem;
    /* line-height:1.4;
    */
    word-break: keep-all;
    font-family: 'LIFEPLUS-Medium', 'sans-serif';
    color: #000;
    -webkit-touch-callout: none;
    box-sizing: border-box;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
}
legend, caption {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    clip: rect(1px 1px 1px 1px);
    word-break: initial;
    word-wrap: initial;
}
a {
    text-decoration: none;
    color: inherit;
}
a[href^="tel"] {
    cursor: default;
}
img {
    vertical-align: middle;
    border: 0 none;
}
fieldset, button {
    background: none;
    border: 0;
}
ul::after, ol::after {
    content: '';
    display: block;
    clear: both;
}
li {
    list-style: none;
}
table {
    position: relative;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
}
iframe {
    width: 100%;
    vertical-align: middle;
    border: 0 none;
}
hr {
    margin: 1.25em 0;
    border: 0 none;
    height: 1px;
    background: #ccc;
}
button, input, optgroup, select, textarea {
    font: inherit;
}
button {
    cursor: pointer;
}
h1, h2, h3, h4, h5, h6 {
    font-weight: 400;
    -webkit-font-smoothing: subpixel-antialiased;
}
input, select, textarea {
    padding: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-border-radius: 0;
    border-radius: 0;
    border: none;
}
input::-ms-clear {
    display: none;
}
input[type=password]::-ms-reveal {
    display: none;
}
b, strong {
    font-weight: 700;
}
em {
    font-style: inherit;
}
* {
    box-sizing: border-box;
}
body {
    min-height: 100%;
    min-height: stretch;
}
html {
    height: stretch;
}
html.font-big {
    font-size: 13px;
}
/* PLACEHOLDER */
input, select, textarea {
    outline: none;
}
::placeholder {
    font-size: 1.6rem;
    color: #999;
    line-height: 1.4;
}
::-webkit-input-placeholder {
    font-size: 1.6rem;
    color: #999;
    line-height: 1.4;
}
::-moz-placeholder {
    font-size: 1.6rem;
    color: #999;
    line-height: 1.4;
}
:-moz-placeholder {
    font-size: 1.6rem;
    color: #999;
    line-height: 1.4;
}
::-ms-input-placeholde {
    font-size: 1.6rem;
    color: #999;
    line-height: 1.4;
}
:-ms-input-placeholder {
    font-size: 1.6rem;
    color: #999;
    line-height: 1.4;
}
/* 말줄임 - 한줄 */
.ellipsis {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    -ms-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.blur img {
    -webkit-filter: blur(6px);
    -moz-filter: blur(6px);
}
/* 말줄임 - 멀티 */
.multiline {
    position: relative;
    width: 100%;
    max-height: 4.2rem;
    margin: auto;
    overflow: hidden;
    text-align: justify;
    line-height: 1.4;
    text-overflow: ellipsis;
    word-break: normal;
    word-wrap: normal;
}
.multiline::before, .multiline::after {
    content: '...';
    position: absolute;
    top: 3em;
    right: 0;
    line-height: 1;
    -ms-wrap-flow: start;
}
/* IE */
.multiline::after {
    background: currentColor;
    color: white;
    top: auto;
}
@supports (-webkit-line-clamp: 2) {
    /* 멀티라인이 2줄일 경우 */
    .multiline {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
    }
    .multiline::before, .multiline::after {
        content: normal;
    }
}
.bot-btn-group.center {
    display: flex;
    justify-content: center;
    margin: 30px 0 0;
}

.bot-btn-group .btn {
    padding: 11px;
    text-align: center;
    font-size: 1.6rem;
    border-radius: 8px;
}
.bot-btn-group .btn.single {
    width: 100%;
}
.bot-btn-group .btn.btn-dark {
    color: #fff;
    background: #000;
}



/* 앱설치안내 페이지 start */
.appinfo {  text-align: center;  padding: 70px 30px;}
.appinfo .appinfo-img {  margin: 30px 0 33px;}
.appinfo .appinfo-img img {  width: calc(100% - 51.2%);  color: #000;}
.appinfo h1 {  font-family:  'LIFEPLUS-Bold', sans-serif; ;  font-size: 30px;}
.appinfo h2 {  padding-top: 22px;  font-size: 20px;  color: #000;}
.appinfo .appinfo-txt1 {  margin-top: 13px;  color: #666;  font-size: 16px;  line-height: 1.46;}
.appinfo .appinfo-txt2 {  margin-top: 20px;  color: #999;  font-size: 14px;  line-height: 1.43;}
/* 앱설치안내 페이지 end */
</style>


// WEBPACK FOOTER //
// src/components/cowork/common/helpDesk/Appstore.vue